import { TFunction } from "i18next";
import type { SnakeCasedPropertiesDeep } from "type-fest";

export type AssetRegistrationJobStatus = "IN_PROGRESS" | "COMPLETED" | "COMPLETED_WITH_ERRORS" | "FAILED" | "CANCELLED";

export interface AssetRegistrationJobDetail {
    jobUuid: string;
    status: AssetRegistrationJobStatus;
    totalRequestedReports: number;
    successfulCount: number;
    failedCount: number;
    totalAssetsRegistered: number;
    startedAt: string;
    completedAt?: string;
}

export type AssetRegistrationJobDetailDto = SnakeCasedPropertiesDeep<AssetRegistrationJobDetail>;

export function toAssetRegistrationJobDetail(dto: AssetRegistrationJobDetailDto): AssetRegistrationJobDetail {
    return {
        jobUuid: dto.job_uuid,
        status: dto.status,
        totalRequestedReports: dto.total_requested_reports,
        successfulCount: dto.successful_count,
        failedCount: dto.failed_count,
        totalAssetsRegistered: dto.total_assets_registered,
        startedAt: dto.started_at,
        completedAt: dto.completed_at,
    };
}

export function getAssetRegistrationTitleKey(notificationType: string | undefined, t: TFunction): string {
    switch (notificationType) {
        case "ASSET_REGISTRATION_STARTED":
            return t("Notification.assetRegistrationNotifications.inProgressTitle");
        case "ASSET_REGISTRATION_FAILED":
            return t("Notification.assetRegistrationNotifications.failureTitle");
        case "ASSET_REGISTRATION_SUCCEEDED":
            return t("Notification.assetRegistrationNotifications.successTitle");
        case "ASSET_REGISTRATION_WARNING":
            return t("Notification.assetRegistrationNotifications.successWithFailTitle");
        default:
            return "";
    }
}
